// 第三方
import { action, observable, reaction, runInAction, configure } from "mobx";
// typings
import { TTimeModule, TCountdownModule } from "../../../services/playground";
import { TActState } from "../../../services/banner";
import { CountdownBannerMod } from "./index";

configure({ isolateGlobalState: true });
export class CountdownStore {
	@observable state: TActState = TActState.OnGoing;
	@observable timer: TTimeModule;
	@observable countDown: number = 0;
	intervalId: NodeJS.Timeout;
	// private moduleId: string;

	constructor(
		// moduleId: string,
		state: TActState,
		timer: TCountdownModule,
		refresh: () => Promise<CountdownBannerMod>,
	) {
		// this.moduleId = moduleId;
		this.state = state;
		this.timer = timer?.time;

		reaction(
			() => this.state,
			(state: TActState) => {
				clearInterval(this.intervalId);
				if (state === TActState.ComingSoon || state === TActState.OnGoing) {
					this.countDown = parseInt(timer?.time?.left || "0", 10);
					this.intervalId = setInterval(() => {
						if (this.countDown <= 0) {
							clearInterval(this.intervalId);
							this.refreshModule(refresh);
							return;
						}
						runInAction("tick", () => {
							this.countDown = this.countDown - 1;
						});
					}, 1000);
				}
			},
			{ fireImmediately: true },
		);
	}

	@action
	// refreshModule = (refresh: () => GetFrontModulesResp) => {
	// 	const result = refresh();
	// 	if (result?.mods && result?.mods[this.moduleId]) {
	// 		runInAction("refresh module", () => {
	// 			const newModule = result.mods[this.moduleId].module;
	// 			this.state = newModule?.state;
	// 			this.timer = newModule?.timer;
	// 			this.countDown = parseInt(newModule?.timer?.time?.left || "0", 10);
	// 		});
	// 	}
	// };
	refreshModule = async (refresh: () => Promise<CountdownBannerMod>) => {
		const result = await refresh();
		if (result) {
			runInAction("refresh module", () => {
				this.state = result.actState;
				this.timer = result.timer?.time;
				this.countDown = parseInt(result.timer?.time?.left || "0", 10);
			});
		}
	};
}
